export default __webpack_public_path__ + "static/media/icon6.1068db27.svg";